const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		showJobDescriptions: true,
		heartbeatRefreshOn: {
			'reconnect': true,
			'resourceChanged.bo_jobs': true,
		},
		displayMode: 'list',
	},

	model: {
		entities: {},
		resourceFilters: {},
		parentFieldConfig: {},
		parentForm: null,
	},

	methods: {
		initRunTime() {
			const storage = this.getStorage()
			if(storage.isServer) return;

			if (!this.model.parentForm) {
				this.closest('base_form_form', c => this.model.parentForm = c)
			}
		},

		getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
			resourceFilters = resourceFilters || {}
			if(utils.collectionSize(this.model.parentFieldConfig) < 1){
				this.model.parentFieldConfig = this.getResourceRegisterContent('fieldConfig') || {}
			}
			const fieldConfig = this.model.parentFieldConfig || {}

			if(actionKey === 'refreshResources'){
				if(utils.collectionSize(this.model.resourceFilters) > 0){
					utils.refReplace(resourceFilters, this.model.resourceFilters);
				}

				if(fieldConfig.showOnRegistrationMandatory){
					resourceFilters.showOnRegistration = true
				}
				if(fieldConfig.showOnCustomerOrderMandatory){
					resourceFilters.showOnRegistration = true
					resourceFilters.showOnCustomerOrder = true
				}
				if(fieldConfig.showOnEmployeeJobSelectionMandatory){
					resourceFilters.showOnRegistration = true
					resourceFilters.showOnEmployeeJobSelection = true
				}
				if(fieldConfig.showOnOfficeEmployeeJobSelectionMandatory){
					resourceFilters.showOnRegistration = true
					resourceFilters.showOnOfficeEmployeeJobSelection = true
				}

				this.model.resourceFilters = resourceFilters;
			}

			return resourceFilters;
		},

		sanitizeResources() {
			this.initRunTime()
			this.model.entities = {}

			const selectedEntities = (this.getResourceRegisterContent('selectedEntities') || {}).dataJSON || {}

			// split resourceData types
			if(((this.resourceData.data || {})[0] || {}).primaryKey === 'jobID'){
				this.model.jobResourcesData = utils.simpleCopy(this.resourceData)
			} else {
				this.model.jobResourcesData = this.model.jobResourcesData || {}
			}

			// init entities
			if (this.model.jobResourcesData.data) {
				let dI, entity, entityID, entityKey, attributes, value
				for (dI in this.model.jobResourcesData.data) {
					entity = this.model.jobResourcesData.data[dI] || {}
					attributes = entity.attributes || {}
					entityID = attributes[entity.primaryKey]
					entityKey = `entity_${entityID}`
					value = (selectedEntities[entityID] || {}).value || 0

					this.model.entities[entityKey] = {
						field: {
							fieldCode: entityID,
							value,
						},
						title: attributes.title,
						attributes,
					}
				}
			}
		},

		onBeforeRender() {
			this.initRunTime()
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers = this.config.heartbeatRefreshOn || {}
			const key = message.heartbeatKey

			if(refreshers[key]){
				this.delayedLastOf('refreshByHeartbeat', () => this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
			}
		},

		value(){
			return this.model.nrOfElementsPerJob || {}
		}
	},

	hooks: {
		onChildChanged: function($element, triggerOptions){
			triggerOptions = triggerOptions || {}

			const nrOfElementsPerJob = this.model.nrOfElementsPerJob = this.model.nrOfElementsPerJob || {}
			const entityID = triggerOptions.fieldCode
			const entityValue = triggerOptions.value
			const entityKey = `entity_${entityID}`
			const entity = this.model.entities[entityKey] || {}
			const entityAttributes = entity.attributes || {}

			if(entityID){
				nrOfElementsPerJob[entityID] = {
					value: 	entityValue,
					title: 	entity.title,
					code: 	entityAttributes.code,
				}
			}

			if(this.model.parentForm){
				this.model.parentForm.fieldToModel('nrOfElementsPerJob', nrOfElementsPerJob)
			}
		},
	},

	handlers: [
		{
			name: 'heartbeat.resourceChanged',
			handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
				this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
			}
		},
		{
			name: 'heartbeat.reconnect',
			handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
				this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
			}
		},
		{
			name: 'onTabDeactivate',
			handle(callerComponent){
				const triggerHeartbeat = this.model.triggerHeartbeat
				if(triggerHeartbeat && this.$ && !this.$.is(':visible')){
					delete this.model.triggerHeartbeat
					this.onHeartbeat(triggerHeartbeat.message, triggerHeartbeat.heartbeatPrewarmedResourceHashes)
				}
			}
		},
	],
}